'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.filters = twentyninetimes.filters || function () {

	function init() {

		var blockContainer = document.querySelector('.js-block-filtering');

		if ( blockContainer ) {
      let action = blockContainer.getAttribute('data-action'),
          resultsContainer = blockContainer.querySelector('.js-results-container');

      filterList(blockContainer, resultsContainer, action);

      if ( blockContainer.classList.contains('js-window-close') ) {
        filtersAccordionClose(blockContainer);
      }
    }
	}

	function filterList(blockContainer, resultsContainer, action) {
    blockContainer.addEventListener('input', (e) => {
      e.stopPropagation();

      if (e.target.tagName.toLowerCase() != 'input')
        return;

      var input = e.target,
          input_name = input.name,
          input_type = input.type,
          input_id = input.id,
          input_value = input.value;

      var filters = input_name == 'productarea'
            ? blockContainer.querySelectorAll('.js-filter-group[data-filter-slug="productarea"]')
            : blockContainer.querySelectorAll('.js-filter-group'),
          new_url = setFilterParams(filters).toString();

      if ( input_name == 'productarea' ) {
        var parent = input.closest('.pg-cat-list__inner'),
            label = parent.querySelector('label[for="'+input_id+'"]');

        scrollToImage(parent, label);

        var current_state = blockContainer.querySelector('.js-current-indicator');
        if ( current_state ) {
          var input_key = input.getAttribute('data-key');
          current_state.style.transform = 'translate3d(calc(100% * '+input_key+'), 0, 0)';
        }
      }

      if ( input_type == 'text' ) {
        searchList(blockContainer, input);
      } else {
        if (window.history.replaceState) {
          //prevents browser from storing history with each change:
          if ( input_value == '*' ) {
            // Remove the parameter "&cats" from the URL
            new_url = new_url.replace(/([&?])cats=[^&]*/, '');
            window.history.replaceState(null, '', new_url);
          } else {
            window.history.replaceState(null, '', new_url);
          }
  
          // setTimeout(function() {
            loadNewResults(resultsContainer, action);
          // }, 300);
        }
      }

      setTimeout(function() {
        var windowWidth = window.innerWidth,
        offset = 71;
  
        if ( windowWidth >= 768 && windowWidth <= 959 ) {
          offset = 111;
        } else if ( windowWidth > 959 ) {
          offset = 143;
        }

        scrollToElement(resultsContainer, offset);
      }, 300);
    });
	}

  function loadNewResults(resultsContainer, action) {
    const query = typeof query_var_block !== 'undefined' 
      ? query_var_block 
      : query_var;
  
    const url = `${ajax_var.url}${window.location.search}`;
    const nonce = ajax_var.nonce;
    const postId = ajax_var.postId;
  
    resultsContainer.classList.add('loading');
  
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: action,
        nonce: nonce,
        query: JSON.stringify(query),
        post_id: postId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((new_posts) => {
        resultsContainer.innerHTML = new_posts;
        resultsContainer.classList.remove('loading');
  
        setTimeout(() => {
          const inViewItems = resultsContainer.querySelectorAll('.in-view-item:not(.visible)');
          if (inViewItems) {
            const test = (item) => {
              if (!item.classList.contains('visible')) {
                item.classList.add('visible');
  
                setTimeout(() => {
                  item.classList.remove('in-view-item');
                }, 600);
              }
            };
            twentyninetimes.inView.init(inViewItems, test, -100);
          }
        }, 0);
  
        query.page = 1;
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Something went wrong... Please try again later');
      });
  }

  function setFilterParams(filters) {
    var url = new URL(window.location.href.split(/[?#]/)[0]),
        params = url.searchParams;

    filters.forEach((filter) => {
      var taxonomy = filter.getAttribute('data-filter-slug'),
          checkedInputs = filter.querySelectorAll('input:checked');

      if ( !checkedInputs.length ) return;

      var inputString = '';

      checkedInputs.forEach((input) => {
        inputString += inputString == ''
          ? input.value
          : ','+input.value;
      });

      if ( inputString != '' ) params.set(taxonomy, inputString);
    }); 

    return url;
  }

  function filtersAccordionClose(blockContainer) {
    let filters = blockContainer.querySelectorAll('.js-filter-group');

    window.addEventListener("click", (e) => {
      var target = e.target;
      if ( target.closest('.filter-group.js-accordion') ) return;

      filters.forEach((filter) => {
        var content = filter.querySelector('.js-accordion-content'),
            toggle = filter.querySelector('.js-accordion-toggle');
            
        var accordionHeight = content.clientHeight;
        content.style.height = accordionHeight + 'px';
    
        setTimeout(function () {
          content.style.height = '0px';
          filter.classList.remove('active');
        }, 10);
    
        toggle.setAttribute('aria-expanded', false);
      });
    });
  }

  function searchList(blockContainer, input) {
    var listContainer = blockContainer.querySelector('.list-product-term'),
        noResults = blockContainer.querySelector('.js-no-results');

    if ( !listContainer ) return;

    var filter = input.value.toLowerCase(),
        terms = listContainer.querySelectorAll('.item-product-term');

    terms.forEach((term) => {
      var products = term.querySelectorAll('.item-product');

      products.forEach((product) => {
        var text = product.textContent.toLowerCase();

        if ( text.indexOf(filter) > -1 ) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });

      // hide item if all products are hidden
      var visibleProducts = term.querySelectorAll('.item-product:not([style*="display: none"])');
      if ( !visibleProducts.length ) {
        term.style.display = 'none';
      } else {
        term.style.display = '';
      }
    });

    // show or hide no results message
    var visibleItems = listContainer.querySelectorAll('.item-product-term:not([style*="display: none"])');
    if ( visibleItems.length ) {
      noResults.style.display = 'none';
    } else {
      noResults.style.display = 'block';
    }
  }

  function scrollToImage(container, element) {
    const scrollLeft = element.offsetLeft - 20;
    container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
    });
  }

  function scrollToElement(element, offset) {
    var top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scroll({
      top: top,
      behavior: 'smooth'
    });
  }

	return {
		init : init
	};

}();